import FornecedoresStore, {
  FornecedoresStoreClass,
} from "./fornecedores.store";
import ProdutoStore, { ProdutoStoreClass } from "./produto.store";
import SonhoStore, { SonhoStoreClass } from "./sonho.store";

export class GlobalStoreClass {
  produtoStore: typeof ProdutoStore;
  fornecedoresStore: typeof FornecedoresStore;
  sonhoStore: typeof SonhoStore;

  constructor() {
    this.produtoStore = new ProdutoStoreClass();
    this.fornecedoresStore = new FornecedoresStoreClass();
    this.sonhoStore = new SonhoStoreClass();
  }
}

const GlobalStore = new GlobalStoreClass();
export default GlobalStore;
